import styled from "styled-components";

export const FilterButton = styled.button`
 background: linear-gradient(90deg, #667eea, #764ba2);
 color: white;
 border: none;
 padding: 0.6rem 1rem;
 border-radius: 8px;
 font-weight: 500;
 cursor: pointer;
 display: flex;
 align-items: center;
 gap: 0.5rem;
 font-size: 0.9rem;
 transition: all 0.2s;
 box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);
 margin-bottom: 1rem;

 &:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
 }

 &:active {
  transform: translateY(0);
 }

 svg {
  width: 16px;
  height: 16px;
 }

 .badge {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 12px;
  padding: 2px 6px;
  font-size: 0.75rem;
  font-weight: 600;
 }
`;

export const ModalOverlay = styled.div`
 position: fixed;
 top: 0;
 left: 0;
 right: 0;
 bottom: 0;
 background: rgba(0, 0, 0, 0.5);
 z-index: 10000;
 display: flex;
 align-items: flex-end;
 justify-content: center;
 animation: fadeIn 0.2s ease;

 @keyframes fadeIn {
  from {
   opacity: 0;
  }
  to {
   opacity: 1;
  }
 }
`;

export const ModalContent = styled.div`
 background: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
 border-radius: 20px 20px 0 0;
 width: 100%;
 max-height: 90vh;
 overflow-y: auto;
 padding: 1.5rem;
 animation: slideUp 0.3s ease;

 @keyframes slideUp {
  from {
   transform: translateY(100%);
  }
  to {
   transform: translateY(0);
  }
 }
`;

export const ModalHeader = styled.div`
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin-bottom: 1.5rem;
 padding-bottom: 1rem;
 border-bottom: ${(props) =>
    props.isDarkMode ? "1px solid #4a5568" : "1px solid #e1e5ee"};
`;

export const ModalTitle = styled.h2`
 margin: 0;
 font-size: 1.25rem;
 font-weight: 600;
 color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#2d3748")};
`;

export const CloseButton = styled.button`
 background: none;
 border: none;
 cursor: pointer;
 padding: 0.5rem;
 display: flex;
 align-items: center;
 justify-content: center;
 color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#4a5568")};
 border-radius: 50%;
 transition: all 0.2s;

 &:hover {
  background: ${(props) => (props.isDarkMode ? "#4a5568" : "#f8f9fd")};
  color: #667eea;
 }

 svg {
  width: 20px;
  height: 20px;
 }
`;

export const FilterSection = styled.div`
 margin-bottom: 2rem;

 &:last-child {
  margin-bottom: 0;
 }
`;

export const FilterSectionTitle = styled.h3`
 margin: 0 0 1rem 0;
 font-size: 1rem;
 font-weight: 600;
 color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#4a5568")};
 display: flex;
 align-items: center;
 gap: 0.5rem;

 svg {
  color: #667eea;
 }
`;

export const FilterTypeSelect = styled.select`
 width: 100%;
 padding: 0.75rem;
 border: ${(props) =>
    props.isDarkMode ? "1px solid #4a5568" : "1px solid #e1e5ee"};
 border-radius: 8px;
 font-size: 1rem;
 margin-bottom: 1rem;
 cursor: pointer;
 background: ${(props) => (props.isDarkMode ? "#1a202c" : "white")};
 color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};

 &:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
 }
`;

export const DateInput = styled.input`
 width: 100%;
 padding: 0.75rem;
 border: ${(props) =>
    props.isDarkMode ? "1px solid #4a5568" : "1px solid #e1e5ee"};
 border-radius: 8px;
 font-size: 1rem;
 margin-bottom: 0.75rem;
 background: ${(props) => (props.isDarkMode ? "#1a202c" : "white")};
 color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#333")};
 color-scheme: ${(props) => (props.isDarkMode ? "dark" : "light")};

 &:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
 }
`;

export const FilterLabel = styled.label`
 display: block;
 font-size: 0.9rem;
 font-weight: 500;
 color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#4a5568")};
 margin-bottom: 0.5rem;
`;

export const FilterActions = styled.div`
 display: flex;
 gap: 1rem;
 margin-top: 2rem;
 padding-top: 1.5rem;
 border-top: ${(props) =>
    props.isDarkMode ? "1px solid #4a5568" : "1px solid #e1e5ee"};
 position: sticky;
 bottom: 0;
 background: ${(props) => (props.isDarkMode ? "#2d3748" : "white")};
`;

export const ActionButton = styled.button`
 flex: 1;
 padding: 0.875rem;
 border: none;
 border-radius: 8px;
 font-weight: 600;
 font-size: 1rem;
 cursor: pointer;
 transition: all 0.2s;

 &.clear {
  background: ${(props) => (props.isDarkMode ? "#4a5568" : "#f8f9fd")};
  color: ${(props) => (props.isDarkMode ? "#e2e8f0" : "#4a5568")};
  border: 1px solid ${(props) => (props.isDarkMode ? "transparent" : "#0e306aff")};

  &:hover {
   background: ${(props) => (props.isDarkMode ? "#2d3748" : "#e1e5ee")};
  }
 }

 &.apply {
  background: linear-gradient(90deg, #667eea, #764ba2);
  color: white;
  box-shadow: 0 2px 4px rgba(102, 126, 234, 0.2);

  &:hover:not(:disabled) {
   transform: translateY(-1px);
   box-shadow: 0 4px 8px rgba(102, 126, 234, 0.3);
  }

  &:disabled {
   opacity: 0.5;
   cursor: not-allowed;
  }
 }
`;

export const ActiveFiltersBadge = styled.div`
 display: flex;
 flex-wrap: wrap;
 gap: 0.5rem;
 margin-top: 1rem;
 padding-top: 1rem;
 border-top: ${(props) =>
    props.isDarkMode ? "1px solid #4a5568" : "1px solid #e1e5ee"};
`;

export const ActiveFilterChip = styled.div`
 background: linear-gradient(
  90deg,
  rgba(102, 126, 234, 0.1),
  rgba(118, 75, 162, 0.1)
 );
 color: #667eea;
 padding: 0.4rem 0.75rem;
 border-radius: 20px;
 font-size: 0.85rem;
 font-weight: 500;
 display: flex;
 align-items: center;
 gap: 0.5rem;
`;
